import { LinkComponentProps } from '@understory-io/leaf/provider';
import { Link } from 'react-router';
import { isClientRoutablePath } from '~/lib/routing/route-registry';

/**
 * Leaf's link adapter. An `href` this app's router owns renders a react-router
 * <Link> (client-side navigation); anything else renders a native <a> (full
 * load — for legacy `apps/web` paths and external/cross-domain links).
 *
 * Ownership comes from `isClientRoutablePath`, so the route registry is the one
 * source of truth and `:locale?`-prefixed internal links (e.g.
 * `/en/checkout/...`) navigate client-side too.
 */
export function ReactRouterLinkComponent(props: LinkComponentProps) {
  const { href, ref, children, ...rest } = props;

  if (href && isClientRoutablePath(href)) {
    return (
      <Link ref={ref} to={href} {...rest} prefetch="intent">
        {children}
      </Link>
    );
  }

  // Cross-domain Connect links (owner storefront FQDNs) leave the site, so they
  // must not leak the referrer or opener.
  const isCrossOrigin = href?.startsWith('http') === true;

  return (
    <a
      ref={ref}
      href={href}
      {...rest}
      rel={isCrossOrigin ? 'noopener noreferrer' : rest.rel}
    >
      {children}
    </a>
  );
}
